// extracted by mini-css-extract-plugin
var _1 = "WhitepaperComponentStyle-module__invest-btn___Kmkod";
var _2 = "WhitepaperComponentStyle-module__invest-component___o0Vak";
var _3 = "WhitepaperComponentStyle-module__invest-btn___Kmkod";
var _4 = "WhitepaperComponentStyle-module__invest-component___o0Vak";
var _5 = "WhitepaperComponentStyle-module__whitepaper-btn___bAwKi";
var _6 = "WhitepaperComponentStyle-module__whitepaper-btn___bAwKi";
export { _1 as "invest-btn", _2 as "invest-component", _3 as "investBtn", _4 as "investComponent", _5 as "whitepaper-btn", _6 as "whitepaperBtn" }
